import {
  assessmentAddQuestionsOwnsSecondaryPanel,
  isAssessmentAddQuestionsPath,
} from "@/lib/focus-workflow"

export const ASSESSMENT_QUESTION_BANK_SECONDARY_PANEL_ID =
  "assessment-question-bank"

export function isAssessmentQuestionBankSecondaryPanelRoute(
  pathname: string,
): boolean {
  return isAssessmentAddQuestionsPath(pathname)
}

export function shouldAssessmentQuestionBankSecondaryPanelBeOpen(
  pathname: string,
  search: string,
): boolean {
  return assessmentAddQuestionsOwnsSecondaryPanel(pathname, search)
}

export function isAssessmentQuestionBankSecondaryPanelVisible(
  pathname: string,
  search: string,
  activePanel: string | null,
): boolean {
  return (
    shouldAssessmentQuestionBankSecondaryPanelBeOpen(pathname, search) ||
    activePanel === ASSESSMENT_QUESTION_BANK_SECONDARY_PANEL_ID
  )
}
